module.exports = __webpack_public_path__ + "static/media/cases_item_2.e65bf980.png";